<div id="attendee" class="registration container">
  <form #attendeeForm="ngForm" name="attendeeForm" (ngSubmit)="forward(attendeeForm)" novalidate appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.ATTENDEE.header' | copy | async }}</h1>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.ATTENDEE.PERSONAL.header' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
          <mat-form-field class="firstNameInput">
            <mat-label for="FirstName" [ngClass]="{'active' : attendee.FirstName}">{{ 'copy.label.FEATURES.NAME.first' | copy | async }}</mat-label>
            <input  matInput name="FirstName" [disabled]="isRegComplete" id="FirstName" [attr.aria-label]="FirstName" type="text"  maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="attendee.FirstName" #FirstName="ngModel" required />
            <mat-error><app-validation  [object]="FirstName" isRequired=true pattern="alpha"></app-validation></mat-error>
          </mat-form-field>
          <mat-form-field class="lastNameInput">
            <mat-label for="LastName" [ngClass]="{'active' : attendee.LastName}">{{ 'copy.label.FEATURES.NAME.last' | copy | async }}</mat-label>
            <input matInput name="LastName" [disabled]="isRegComplete" id="LastName" [attr.aria-label]="LastName" type="text"  maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="attendee.LastName" #LastName="ngModel" required />
            <mat-error><app-validation  [object]="LastName" isRequired=true pattern="alpha"></app-validation></mat-error>
          </mat-form-field>
          <mat-form-field class="suffixInput">
            <mat-label for="Suffix">{{ 'copy.label.FEATURES.NAME.suffix' | copy | async }}</mat-label>
            <mat-select name="Suffix" [disabled]="isRegComplete" id="Suffix" aria-label="Suffix" [(ngModel)]="attendee.Suffix" matNativeControl>
              <mat-option *ngFor="let obj of suffixList" [value]="obj.code">{{ obj.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-label class="w-100 font-weight-bold">{{ 'copy.label.FEATURES.NAME.preferredheading' | copy | async }}</mat-label>
          <mat-form-field class="w-100">
            <mat-label for="PreferredFirst" [ngClass]="{'active' : attendee.PreferredFirstName}">{{ 'copy.label.FEATURES.NAME.preferredfirst' | copy | async }}</mat-label>
            <input matInput name="PreferredFirst" id="PreferredFirst" aria-label="PreferredFirst" type="text" maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="attendee.PreferredFirstName" #PreferredFirst="ngModel" />
            <mat-error><app-validation  [object]="PreferredFirst" isRequired=true pattern="alpha"></app-validation></mat-error>
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label for="PreferredLast" [ngClass]="{'active' : attendee.PreferredLastName}">{{ 'copy.label.FEATURES.NAME.preferredlast' | copy | async }}</mat-label>
            <input matInput name="PreferredLast" id="PreferredLast" [attr.aria-label]="PreferredLast" type="text" maxlength="25" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="attendee.PreferredLastName" #PreferredLast="ngModel" />
            <mat-error><app-validation  [object]="PreferredLast" isRequired=true pattern="alpha"></app-validation></mat-error>
          </mat-form-field>
          <!--Benefit and Non-Benefit Tracks-->
          <div class="w-100" *ngIf="varTrack.Value === 'Benefit Advisor' || varTrack.Value === 'Non-Benefit Advisor' || varTrack.Value === 'Commonwealth Client'">
            <mat-label class="w-100 font-weight-bold">{{ 'copy.label.ATTENDEE.EMPLOYMENT.header' | copy | async }}</mat-label>
            <mat-form-field class="w-100">
              <mat-label for="BusinessName" aria-labelledby="BusinessName" [ngClass]="{'active' : attendee.BusinessName}">{{ 'copy.label.FEATURES.COMPANY.label2' | copy | async }}</mat-label>
              <input matInput name="BusinessName" id="BusinessName" [attr.aria-label]="BusinessName" type="text" maxlength="50" pattern="^[\w\s!@\-\_:'&,.\/?]*" [(ngModel)]="attendee.BusinessName" #BusinessName="ngModel" required />
              <mat-error><app-validation  [object]="BusinessName" isRequired="attendee.PAXTypeNo !== 23 && attendee.PAXTypeNo !== 24" pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="attendee.PAXTypeNo !== 50" class="w-100">
              <mat-label for="MasterRep" aria-labelledby="MasterRep" [ngClass]="{'active' : varMasterRepID.Value}">{{ 'copy.label.ATTENDEE.mastercreditadvisor' | copy | async }}</mat-label>
              <input matInput name="MasterRep" id="MasterRep" [attr.aria-label]="MasterRep" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varMasterRepID.Value" #MasterRep="ngModel" required />
              <mat-error><app-validation  [object]="MasterRep" pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div> 
          <!--BusinessName only editable when not loaded-->
          <!--Sponsor, Corp Guest 22, Media/Press 25, Event producer/supplier 26, Corporate Guest 22, Board Member 29, Entertainment 40-->
          <div class="w-100" *ngIf="varTrack.Value === 'Sponsor' || attendee.PAXTypeNo === 25 || attendee.PAXTypeNo === 26 || attendee.PAXTypeNo === 22 || attendee.PAXTypeNo === 29 || attendee.PAXTypeNo === 40 || attendee.PAXTypeNo === 54">
            <mat-label class="w-100 font-weight-bold">{{ 'copy.label.ATTENDEE.EMPLOYMENT.header' | copy | async }}</mat-label>
            <mat-form-field *ngIf="attendee.PAXTypeNo !== 29" class="w-100">
              <mat-label for="BusinessName" aria-labelledby="BusinessName" [ngClass]="{'active' : attendee.BusinessName}">{{ 'copy.label.FEATURES.COMPANY.label' | copy | async }}</mat-label>
              <input matInput name="BusinessName" id="BusinessName" [attr.aria-label]="BusinessName" type="text" maxlength="50" pattern="^[\w\s!@\-\_:'&,.\/?]*" [(ngModel)]="attendee.BusinessName" #BusinessName="ngModel" required [disabled]="attendee.$mtcLoadedCompanyName"/>
              <mat-error><app-validation  [object]="BusinessName" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="attendee.PAXTypeNo === 29" class="w-100">
              <mat-label for="BusinessName" aria-labelledby="BusinessName" [ngClass]="{'active' : attendee.BusinessName}">{{ 'copy.label.FEATURES.COMPANY.label' | copy | async }}</mat-label>
              <input matInput name="BusinessName" id="BusinessName" [attr.aria-label]="BusinessName" type="text" maxlength="50" pattern="^[\w\s!@\-\_:'&,.\/?]*" [(ngModel)]="attendee.BusinessName" #BusinessName="ngModel" required/>
              <mat-error><app-validation  [object]="BusinessName" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label for="JobTitle" aria-labelledby="JobTitle" [ngClass]="{'active' : attendee.JobTitle}">{{ 'copy.label.FEATURES.JOBTITLE.label' | copy | async }}</mat-label>
              <input matInput name="JobTitle" id="JobTitle" [attr.aria-label]="JobTitle" type="text" maxlength="35" pattern="^[\w\s!@\-\&_\\:',.\/?]*" [(ngModel)]="attendee.JobTitle" #JobTitle="ngModel" required />
              <mat-error><app-validation  [object]="JobTitle" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>
          <!--Home Office, Home Office MC-->
          <div class="w-100" *ngIf="attendee.PAXTypeNo === 20 || attendee.PAXTypeNo === 21 || attendee.PAXTypeNo === 52">
            <mat-label class="w-100 font-weight-bold">{{ 'copy.label.ATTENDEE.EMPLOYMENT.header' | copy | async }}</mat-label>
            <mat-form-field class="w-100">
              <mat-label for="JobTitle" aria-labelledby="JobTitle" [ngClass]="{'active' : attendee.JobTitle}">{{ 'copy.label.FEATURES.JOBTITLE.label2' | copy | async }}</mat-label>
              <input matInput name="JobTitle" id="JobTitle" [attr.aria-label]="JobTitle" type="text" maxlength="75" pattern="^[\w\s!@\-\&_\\:',.\/?]*" [(ngModel)]="attendee.JobTitle" #JobTitle="ngModel" required/>
              <mat-error><app-validation  [object]="JobTitle" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
              <mat-label for="Department" aria-labelledby="Department" [ngClass]="{'active' : varDepartment.Value}">{{ 'copy.label.ATTENDEE.department' | copy | async }}</mat-label>
              <input matInput name="Department" id="Department" [attr.aria-label]="Department" type="text" maxlength="35" pattern="^[\w\s!@&\-\_\\:',.\/?]*" [(ngModel)]="varDepartment.Value" #Department="ngModel" required />
              <mat-error><app-validation  [object]="Department" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
            <mat-form-field class="w-100" *ngIf="attendee.PAXTypeNo === 20 || attendee.PAXTypeNo === 52">
              <mat-label for="committeeMemberValue">{{'copy.label.ATTENDEE.committeemember' | copy | async}}</mat-label>
              <mat-select name="committeeMemberValue" id="committeeMemberValue" #committeeMemberValue="ngModel" [(ngModel)]="committeeMember.Value" required>
                <mat-option *ngFor="let ss of committeeMemberList" value="{{ss}}">{{ss}}</mat-option>
              </mat-select>
            </mat-form-field>  
          </div>
          <!--IAS Recruit, IS Recruit-->
          <div class="w-100" *ngIf="attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24">
            <mat-label class="w-100 font-weight-bold">{{ 'copy.label.ATTENDEE.EMPLOYMENT.header' | copy | async }}</mat-label>
            <mat-form-field class="w-100">
              <mat-label for="BusinessName" aria-labelledby="BusinessName" [ngClass]="{'active' : attendee.BusinessName}">{{ 'copy.label.FEATURES.COMPANY.labelrecruits' | copy | async }}</mat-label>
              <input matInput name="BusinessName" id="BusinessName" [attr.aria-label]="BusinessName" type="text" maxlength="50" pattern="^[\w\s!@\-\_:'&,.\/?]*" [(ngModel)]="attendee.BusinessName" #BusinessName="ngModel" />
              <mat-error><app-validation  [object]="BusinessName" isRequired="attendee.PAXTypeNo !== 23 && attendee.PAXTypeNo !== 24" pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
          </div>
          <!--Professional Designations-->
          <div class="w-100" *ngIf="attendee.PAXTypeNo !== 25">
            <br/>
            <label class="w-100" for="firstTime">{{'copy.label.ATTENDEE.professionaldesignations' | copy | async }}</label>
            <div class="w-100">
              <div class="d-flex justify-content-between w-100 multiSelect">
                <mat-form-field class="w-33">
                  <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async }}</mat-label>
                  <mat-select disableRipple name="profdesig1" id="profdesig1" #profdesig1="ngModel" [(ngModel)]="profDesig1" (ngModelChange)="changeprofdesig1()">
                    <mat-option *ngFor="let ss of profdesiglist1" value="{{ss}}">{{ss}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-33">
                  <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
                  <mat-select disableRipple name="profdesig2" id="profdesig2" #profdesig2="ngModel" [(ngModel)]="profDesig2" (ngModelChange)="changeprofdesig2()">
                    <mat-option *ngFor="let ss of profdesiglist2" value="{{ss}}">{{ss}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-33">
                  <mat-label>{{'copy.label.DEMOGRAPHICS.shirtsizeplaceholder' | copy | async}}</mat-label>
                  <mat-select disableRipple name="profdesig3" id="profdesig3" #profdesig3="ngModel" [(ngModel)]="profDesig3" (ngModelChange)="changeprofdesig3()">
                    <mat-option *ngFor="let ss of profdesiglist3" value="{{ss}}">{{ss}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-form-field class="w-100" *ngIf="profDesig1 === 'Other'">
                <mat-label for="prodesigother1" aria-labelledby="prodesigother1" [ngClass]="{'active' : prodesigother1}">{{ 'copy.label.ATTENDEE.otherdesig' | copy | async }}</mat-label>
                <input matInput name="prodesigother1" id="prodesigother1" [attr.aria-label]="prodesigother1" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="proDesigother1" #prodesigother1="ngModel" required/>
                <app-validation  [object]="prodesigother1" isRequired=true pattern="alphanum"></app-validation>
              </mat-form-field>
              <mat-form-field class="w-100" *ngIf="profDesig2 === 'Other'">
                <mat-label for="prodesigother2" aria-labelledby="prodesigother2" [ngClass]="{'active' : prodesigother2}">{{ 'copy.label.ATTENDEE.otherdesig' | copy | async }}</mat-label>
                <input matInput name="prodesigother2" id="prodesigother2" [attr.aria-label]="prodesigother2" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="proDesigother2" #prodesigother2="ngModel" required/>
                <app-validation  [object]="prodesigother2" isRequired=true pattern="alphanum"></app-validation>
              </mat-form-field>
              <mat-form-field class="w-100" *ngIf="profDesig3 === 'Other'">
                <mat-label for="prodesigother3" aria-labelledby="prodesigother3" [ngClass]="{'active' : prodesigother3}">{{ 'copy.label.ATTENDEE.otherdesig' | copy | async }}</mat-label>
                <input matInput name="prodesigother3" id="prodesigother3" [attr.aria-label]="prodesigother3" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="proDesigother3" #prodesigother3="ngModel" required/>
                <app-validation  [object]="prodesigother3" isRequired=true pattern="alphanum"></app-validation>
              </mat-form-field>
            </div>
          </div>
        </div>
      </article>
    </section>
    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.ATTENDEE.CONTACT.header' | copy | async }}
        </div>
      </div>
      <article>
        <div class="card-body w-100">
        <div class="mb-3" [innerHTML]="'copy.label.ATTENDEE.CONTACT.warning' |copy |async"></div>
        <div class="md-form">
          <label>{{ 'copy.label.FEATURES.ADDRESS.business' | copy | async }}</label>
        </div>
        <!-- Business Address -->
        <app-address class="w-100"  [isRequired]=true [resident]=true [attendee]="attendee" [address]="workAddress" groupname="workAddress" name="workAddress"></app-address>
        <app-phone [phone]="workPhone"  isRequired=true groupname="workPhone" label="copy.label.ATTENDEE.CONTACT.bizphonelabel"></app-phone>
        <app-phone [phone]="mobilePhone"  isRequired=true groupname="mobilePhone" label="copy.label.ATTENDEE.CONTACT.cellphonelabel"></app-phone>
        <!-- Email -->
        <p [innerHTML]="'copy.label.ATTENDEE.CONTACT.emailInstructions' |copy |async"></p>
        <app-email class="w-100" [model]="emailAddress" verify></app-email>
      </div>
  </article>
</section>
<!-- Emergency Contact Section -->
<section class="card">
  <div class="card-header">
    <div class="card-title">
      {{ 'copy.label.ATTENDEE.EMERGENCY.header' | copy | async }}
    </div>
  </div>
  <article>
    <div class="card-body w-100">
      <p>Please enter contact information for the person we should contact in case of an emergency while you are traveling. Please do not enter the name of a person who is traveling with you.</p>
      <mat-form-field class="w-100">
        <mat-label for="attendeeemailverify" [ngClass]="{'active' : attendee.EmergencyContact.EmergencyContactName}">
          {{ 'copy.label.FEATURES.EMERGENCY.namelabel' | copy | async }}
        </mat-label>
        <input matInput name="EmergencyContactName" id="EmergencyContactName" aria-label="EmergencyContactName"  type="text" maxlength="30" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="attendee.EmergencyContact.EmergencyContactName" #EmergencyContactName="ngModel" required />
        <mat-error><app-validation  [object]="EmergencyContactName" isRequired=true pattern="alpha"></app-validation></mat-error>
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label for="EmergencyContactRelation" aria-labelledby="EmergencyContactRelation" [ngClass]="{'active' : attendee.EmergencyContact.EmergencyContactRelation}">{{ 'copy.label.FEATURES.EMERGENCY.relationshiplabel' | copy | async }}</mat-label>
        <mat-select name="EmergencyContactRelation" id="EmergencyContactRelation"  [(ngModel)]="attendee.EmergencyContact.EmergencyContactRelation" #EmergencyContactRelation="ngModel" required>
          <mat-option *ngFor="let obj of relationlist" [value]="obj">{{ obj }}</mat-option>
        </mat-select>
        <mat-error>
        <app-validation  [object]="EmergencyContactRelation" isRequired=true pattern="alpha"></app-validation></mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" *ngIf="attendee.EmergencyContact.EmergencyContactRelation === 'Other'">
        <mat-label >{{ 'copy.label.ATTENDEE.emerrelother' | copy | async }}</mat-label>
        <input matInput name="EmergencyContactRelationOther" id="EmergencyContactRelationOther" aria-label="EmergencyContactRelationOther" type="text" maxlength="30" pattern="[a-zA-Z ]+" [(ngModel)]="relationother" #EmergencyContactRelationOther="ngModel" required /> 
      </mat-form-field>
      <app-phone [phone]="emerContactMainPhone"  isRequired=true groupname="emerContactMainPhone" label="copy.label.FEATURES.EMERGENCY.phonelabel"></app-phone>
      <app-phone [phone]="emerContactAltPhone"  isRequired=false groupname="emerContactAltPhone" label="copy.label.FEATURES.EMERGENCY.altphonelabel"></app-phone>
    </div>
  </article>
</section>
<!-- Admin Section -->
<section class="card">
  <div class="card-header">
    <div class="card-title">
      {{ 'copy.label.ATTENDEE.ADMIN.header' | copy | async }}
    </div>
  </div>
  <article>
    <div class="card-body w-100">
      <div class="w-100 required">
        <label class="w-100 required">{{'copy.label.ATTENDEE.ADMIN.label' |copy | async}}</label>
        <mat-radio-group class="w-100" [(ngModel)]="enrollment.$mtcHasAdminContact" required #admin="ngModel" name="hasAdmin">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
          <div class="w-100">
            <small class="text-danger"><app-validation  [object]="admin" isRequired=true></app-validation></small>
          </div>
        </mat-radio-group>
      </div>
      <mat-form-field class="w-100" *ngIf="enrollment.$mtcHasAdminContact === true">
        <mat-label for="AdminContactName" [ngClass]="{'active' : adminContact.AdminContactName}">{{
          'copy.label.FEATURES.ADMIN.namelabel' | copy | async
          }}</mat-label>
        <input matInput name="AdminContactName" id="AdminContactName" aria-label="AdminContactName"  type="text" maxlength="60" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="adminContact.AdminContactName" #AdminContactName="ngModel" required />
        <mat-error><app-validation  [object]="AdminContactName" isRequired=true pattern="alphanum"></app-validation></mat-error>
      </mat-form-field>
      <app-phone [phone]="adminPhone"  isRequired=true groupname="adminContactPhone" label="copy.label.FEATURES.ADMIN.phonelabel" *ngIf="enrollment.$mtcHasAdminContact === true"></app-phone>
      <mat-form-field class="w-100" *ngIf="enrollment.$mtcHasAdminContact === true">
        <mat-label for="adminemail" [ngClass]="{'active' : adminContact.AdminContactEmailAddress}">{{ 'copy.label.FEATURES.ADMIN.email' | copy | async }}</mat-label>
        <input matInput type="text" name="adminemail" id="adminemail" aria-label="adminemail"  maxlength="100" [(ngModel)]="adminContact.AdminContactEmailAddress" pattern="[a-zA-Z0-9._'%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,125}[a-zA-Z]{2,63}" #adminemail="ngModel" required />
        <mat-error><app-validation  [object]="adminemail" isRequired=true pattern="email"></app-validation></mat-error>
      </mat-form-field>
    </div>
  </article>
</section>
<!-- Dietary Section -->
<section class="card">
  <div class="card-header">
    <div class="card-title">
      {{ 'copy.label.ATTENDEE.DIETARY.header' | copy | async }}
    </div>
  </div>
  <article>
    <div class="card-body w-100">
      <div [innerHTML]="'copy.html.WashingtonHealthLaw ' |copy |async | safeHtml"></div>
      <div class="w-100 required">
        <label for="DietaryNeed" aria-labelledby="DietaryNeed">{{ 'copy.label.FEATURES.DIETARY.label' | copy | async }}</label>
      </div>
      <div class="w-100">
        <div *ngFor="let meal of mealList">
          <div class="agreeCheckbox">
            <div class="checkboxFlexContainer">
              <mat-checkbox *ngIf="meal.name !== 'Other' && meal.name !== 'Food Allergy'" name="meal_{{ meal.name }}" [ngModel]="attendee.DietaryConsiderations.includes(meal.name)" (change)="mealUpdate(meal)" aria-labelledby="{{ meal.code }}_label" [required]="!hasdietary()"></mat-checkbox>
              <mat-checkbox *ngIf="meal.name === 'Other'" name="meal_{{ meal.name }}" [(ngModel)]="dietaryOtherCheckbox" (change)="mealUpdate(meal)" aria-labelledby="{{ meal.code }}_label" [required]="!hasdietary()"></mat-checkbox>
              <mat-checkbox *ngIf="meal.name === 'Food Allergy'" name="meal_{{ meal.name }}" [(ngModel)]="allergyCheckbox" (change)="mealUpdate(meal)" aria-labelledby="{{ meal.code }}_label" [required]="!hasdietary()"></mat-checkbox>
              <label id="{{ meal.code }}_label">{{ meal.name }}</label>
            </div>
          </div>
        </div>
      </div>

      
      <div *ngIf="attendee.$mtcShowDietaryDescription" class="w-100">
          <mat-form-field class="w-100">
              <mat-label for="dietDesc" aria-labelledby="dietDesc">
                  {{ 'copy.label.FEATURES.PERSONAL.considerationDescription' | copy | async }}</mat-label>
              <mat-select name="dietDesc" id="dietDesc" aria-label="dietDesc" [(ngModel)]="dietaryDescription.Value"
                  matNativeControl required>
                  <mat-option *ngFor="let obj of considerationReasonList" [value]="obj.name">{{ obj.name }}</mat-option>
              </mat-select>
          </mat-form-field>
      </div>

      <div *ngIf="dietaryDescription.Value === 'Other'" class="w-100">
          <div class="d-flex justify-content-start" >
              <mat-form-field class="w-100">
                  <mat-label for="considerationDescriptionOther" aria-labelledby="considerationDescriptionOther">
                      {{ 'copy.label.FEATURES.PERSONAL.considerationDescriptionOther' | copy | async }}</mat-label>
                      <textarea matInput class="w-100" name="considerationDescriptionOther" id="considerationDescriptionOther"
                      aria-label="Consideration Description Other" [(ngModel)]="attendee.$mtcDietaryDescriptionOther"
                      maxlength="225" required pattern="^[\w\s!@\-\_:',.\/?]*" #considerationDescriptionOther="ngModel"></textarea>
                      <mat-error><app-validation [object]="considerationDescriptionOther" isRequired=true pattern="alphanum"></app-validation></mat-error>
              </mat-form-field>
          </div>
      </div>

      <div class="w-100" *ngIf="dietaryOtherCheckbox === true || allergyCheckbox === true">
        <div class="d-flex justify-content-start">
          <mat-form-field class="w-100">
            <mat-label for="DietaryConsiderations">{{ 'copy.label.FEATURES.DIETARY.otherlabel' | copy | async }}</mat-label>
            <textarea matInput class="w-100" name="DietaryConsiderations" id="DietaryConsiderations" aria-label="DietaryConsiderations" [(ngModel)]="mealOther" #DietaryConsiderations="ngModel" maxlength="125" pattern="^[\w\s!@\-\_:',.\/?]*" required></textarea>
            <mat-error><app-validation  [object]="DietaryConsiderations" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
        </div>
      </div>

      <mat-error *ngIf="hasdietary() === false && enrollment.$mtcshowselecterror">{{ 'copy.label.ATTENDEE.adaError' | copy | async }}</mat-error>
      <!-- Personal -->
      <div class="w-100 required">
        <label for="DietaryNeed" aria-labelledby="DietaryNeed">{{ 'copy.label.FEATURES.PERSONAL.heading' | copy | async }}</label>
      </div>
      
      <div class="w-100" >
        <div *ngFor="let considerations of personalConsiderationsList">
          <div class="agreeCheckbox">
            <div class="checkboxFlexContainer">
              <mat-checkbox name="considerations_{{ considerations.name }}" [ngModel]="includes(attendee.DisabilityType,considerations.code)" (change)="considerationUpdate(considerations)" aria-labelledby="{{ considerations.code }}_label" [required]="!haspersonalconsiderations()"></mat-checkbox>
              <label id="{{ considerations.code }}_label">{{ considerations.name }}</label>
          <!-- {{personalConsiderations.invalid}} -->
            </div>
          </div>
        </div>
      </div>
      
      <mat-error *ngIf="haspersonalconsiderations() === false && enrollment.$mtcshowselecterror">{{ 'copy.label.ATTENDEE.adaError' | copy | async }}</mat-error>
      <div class="w-100" *ngIf="adaOtherCheckbox === true">
        <div class="d-flex justify-content-start">
          <mat-form-field class="w-100 longQuestionText">
            <mat-label for="PersonalConsiderations" aria-labelledby="PersonalConsiderations">{{ 'copy.label.FEATURES.PERSONAL.otherlabel' | copy | async }}</mat-label>
            <textarea matInput class="w-100" name="PersonalConsiderations" id="PersonalConsiderations" aria-label="PersonalConsiderations" [(ngModel)]="attendee.PersonalConsiderations" #PersonalConsiderations="ngModel" maxlength="225" pattern="^[\w\s!@\-\_:',.\/?]*" required></textarea>
            <mat-error><app-validation  [object]="PersonalConsiderations" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-100 required" *ngIf="(varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor' || varTrack.Value==='Home Office' || varTrack.Value==='Commonwealth Client' || attendee.PAXTypeNo === 27 || attendee.PAXTypeNo === 49 || 
          attendee.PAXTypeNo === 22 || attendee.PAXTypeNo === 23 || attendee.PAXTypeNo === 24 || attendee.PAXTypeNo === 40)">
        
        <br/>
        <label class="w-100" for="adaSeating" aria-labelledby="adaSeating">
          <span [innerHTML]="'copy.label.DEMOGRAPHICS.adaSeatingLabel'|copy|async"></span>
        </label>
        <mat-radio-group class="w-100" [(ngModel)]="varAdaSeating.Value" name="adaSeatingValue" required>
          <mat-radio-button value="Yes">Yes</mat-radio-button>
          <mat-radio-button value="No">No</mat-radio-button>
        </mat-radio-group>  
      </div>

      <div>
        <label class="w-100" for="scooter">{{'copy.label.FEATURES.DIETARY.scooter1' | copy | async }}</label>
        <mat-form-field class="w-100">
          <mat-label>{{'copy.label.FEATURES.DIETARY.scooter2' | copy | async}}</mat-label>
          <mat-select disableRipple name="scooter" id="scooter" #scooter="ngModel" [(ngModel)]="varScooter.Value">
            <mat-option *ngFor="let ss of yesno" value="{{ss}}">{{ss}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100" *ngIf="varScooter.Value === 'Yes'">
          <mat-label for="scootercomment" aria-labelledby="scootercomment" [ngClass]="{'active' : scootercomment}">{{'copy.label.FEATURES.DIETARY.scooter3' | copy | async }}</mat-label>
          <input  class="w-100"  matInput name="scootercomment" id="scootercomment" [attr.aria-label]="scootercomment" type="text" maxlength="100" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varScooterComments.Value" #scootercomment="ngModel" required/>
          <mat-error><app-validation  [object]="scootercomment" isRequired=true pattern="alphanum"></app-validation></mat-error>
        </mat-form-field>
     </div>
    </div>
  </article>
</section>
<div class="button_group d-flex">
  <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
    <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
    {{ 'copy.label.GLOBAL.goback' | copy | async }}
  </button>
  <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
    {{ 'copy.label.GLOBAL.continue' | copy | async }}
    <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
  </button>
  <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
    <i class="fas fa-spinner fa-spin"></i>
  </button>
</div>
</form>
</div>
